import { defineMessages } from 'react-intl';

const translations = {
  formStep: {
    backup: {
      description: {
        id: 'pages.profile.form.steps.backup.description',
        defaultMessage: 'Select one or both backup methods and enter the required information.',
        description: 'description of the backup methods step of the 2fa configure form',
      },
    },
  },
  errors: {
    noChannelSelected: {
      id: 'pages.profile.form.steps.backup.errors.noChannelSelected',
      defaultMessage: 'Please choose a backup methode.',
      description: 'error message when no channel is selected',
    },
  },
  fields: {
    email: {
      label: {
        id: 'properties.email',
        defaultMessage: 'Email address',
        description: 'label of the form field email address',
      },
    },
    emailCheckbox: {
      label: {
        id: 'pages.profile.sections.twofa.backupMethods.email',
        defaultMessage: 'Email',
        description: 'label of the checkbox email',
      },
    },
    phoneNumber: {
      label: {
        id: 'properties.phoneNumber',
        defaultMessage: 'Phone number',
        description: 'label of the checkbox sms',
      },
    },
    smsCheckbox: {
      label: {
        id: 'pages.profile.sections.twofa.backupMethods.sms',
        defaultMessage: 'SMS',
        description: 'label of the checkbox sms',
      },
    },
  },
  formActions: {
    next: {
      id: 'formActions.next',
      defaultMessage: 'Next',
      description: 'label of the form action next button',
    },
  },
};

export default defineMessages(translations);
